import { persist } from 'zustand/middleware';
import { create } from 'zustand';

// Since this is very unlikely to change and we are going to store the user's most used traits in localstorage anyway,
// We can just hardcode it here use the results of today's most used traits based on jack's query (https://redash.scale.com/queries/130301/source) instead of actually fetching it

// Most used traits based on the above, traitName: timesUsed
const DEFAULT_USED_TRAITS = {
  recallToReviewLevel: 15,
  sendTaskFromResponse: 14,
  restartPipelineForTask: 13,
  syncTaskInfoWithMongo: 12,
  chatTaskRecallToReviewLevel: 11,
};

type V3TraitsStore = {
  mostUsedTraits: Record<string, number>;
};

export const useV3TraitsStore = create<V3TraitsStore>()(
  persist(
    () =>
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      ({
        mostUsedTraits: DEFAULT_USED_TRAITS,
      } as V3TraitsStore),
    {
      // Local Storage key
      name: 'v3-traits-store',
      partialize: ({ mostUsedTraits }) => ({ mostUsedTraits }),
    },
  ),
);
